import { render, staticRenderFns } from "./PcNews1.vue?vue&type=template&id=3015ae41&scoped=true"
import script from "./PcNews1.vue?vue&type=script&lang=js"
export * from "./PcNews1.vue?vue&type=script&lang=js"
import style0 from "./PcNews1.vue?vue&type=style&index=0&id=3015ae41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015ae41",
  null
  
)

export default component.exports